import SvgIcon from './svg-icon/index.vue'
import YmGroup from './ym-group/index.vue'
import YmUploadImg from './ym-uploadImg/index.vue'
import YmScrollBox from './ym-scrollBox/index.vue'
import YmTab from './ym-tab/index.vue'
import YmEditor from './ym-editor/index.vue'
import YmUploadVideo from './ym-uploadVideo/index.vue'

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    SvgIcon: typeof SvgIcon
    YmGroup: typeof YmGroup
    YmScrollBox: typeof YmScrollBox
    YmTab: typeof YmTab
    YmEditor: typeof YmEditor
    YmUploadImg: typeof YmUploadImg
  }
}

export default {
  install(app: any) {
    app.component('svg-icon', SvgIcon)
    app.component('YmGroup', YmGroup)
    app.component('YmUploadImg', YmUploadImg)
    app.component('YmUploadVideo', YmUploadVideo)
    app.component('YmScrollBox', YmScrollBox)
    app.component('YmTab', YmTab)
    app.component('YmEditor', YmEditor)
  }
}
